export const AREA_DROPDOWN_QUERY = `
  id
  name
  enabled
`;
